import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Importaciones de Guards.
import { authGuard } from './guards/auth.guard';
import { loginGuard } from './guards/login.guard';
import { roleGuard } from './guards/role.guard';

// Importaciones de componentes.
import { ProductsComponent } from './pages/products/products.component';
import { ActivationComponent } from './pages/activation/activation.component';
import { ActivationSettingsComponent } from './pages/settings/activation-settings/activation-settings.component';
import { EmployeeSettingsComponent } from './pages/settings/employee-settings/employee-settings.component';
import { GeneralSettingsComponent } from './pages/settings/general-settings/general-settings.component';
import { HostSettingsComponent } from './pages/settings/host-settings/host-settings.component';
import { LicenseSettingsComponent } from './pages/settings/license-settings/license-settings.component';
import { LoginComponent } from './pages/login/login.component';
import { LogsSettingsComponent } from './pages/settings/logs-settings/logs-settings.component';
import { PasswordSettingsComponent } from './pages/settings/password-settings/password-settings.component';
import { ProductSettingsComponent } from './pages/settings/product-settings/product-settings.component';
import { ProfileSettingsComponent } from './pages/settings/profile-settings/profile-settings.component';
import { SettingsComponent } from './pages/settings/settings.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard],
  },
  {
    path: 'products',
    component: ProductsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'activations/:id',
    component: ActivationComponent,
    canActivate: [authGuard],
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [authGuard],
    children: [
      { path: 'profile', component: ProfileSettingsComponent },
      { path: 'password', component: PasswordSettingsComponent },
      { path: 'activation', component: ActivationSettingsComponent },
      {
        path: 'employee',
        canActivate: [roleGuard],
        component: EmployeeSettingsComponent,
      },
      {
        path: 'product',
        canActivate: [roleGuard],
        component: ProductSettingsComponent,
      },
      {
        path: 'license',
        canActivate: [roleGuard],
        component: LicenseSettingsComponent,
      },
      {
        path: 'host',
        canActivate: [roleGuard],
        component: HostSettingsComponent,
      },
      {
        path: 'general',
        canActivate: [roleGuard],
        component: GeneralSettingsComponent,
      },
      {
        path: 'logs',
        canActivate: [roleGuard],
        component: LogsSettingsComponent,
      },
      { path: '**', pathMatch: 'full', redirectTo: 'profile' },
    ],
  },
  { path: '**', pathMatch: 'full', redirectTo: 'login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
